import SUBSCRIPTION_ACTION from '../actionTypes/Subscriptions';
import VEHICLE_CAPABLE_ACTION from '../actionTypes/VehicleCapable';
import { QRVALUE_ACTION_TYPES } from '../actionTypes';
import FORGEROCK_ACTION_TYPES from '../actionTypes/ForgeRock';

// reducer with initial state
const initialState = {
  loading: false,
  error: null,
  remoteService: false,
};

const subscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBSCRIPTION_ACTION.IS_SUBSCRIPTION:
      return { ...state, loading: true };
    case SUBSCRIPTION_ACTION.SUBSCRIPTION_ERROR:
      return { ...state, error: action.payload, loading: false };
    case SUBSCRIPTION_ACTION.SUBSCRIPTION_SUCCESS:
      return { ...state, remoteService: action.payload, loading: false, error: null };
    case VEHICLE_CAPABLE_ACTION.VEHICLE_CAPABLE_ERROR:
    case QRVALUE_ACTION_TYPES.POST.IN_PROGRESS:
    case FORGEROCK_ACTION_TYPES.AUTHORIZED_SUCCESS:
      return { ...state, error: null };
    default:
      return state; // return initial state by default
  }
};

export default subscriptionReducer;
